// Shared by the Report Builder pages. Field labels and column names stay in English on purpose:
// they become CSV headings, which files such as the landlord's tenant sales file expect in English.

export function fieldMap(meta) {
  const map = {};
  (meta?.fields || []).forEach((f) => (map[f.key] = f));
  return map;
}

export function columnName(meta, column) {
  if (column.title && column.title.trim()) return column.title.trim();
  const field = fieldMap(meta)[column.field];
  const label = field ? field.label : column.field;
  return column.agg ? `${meta.aggregate_words[column.agg]} ${label.toLowerCase()}` : label;
}

export function emptyDefinition() {
  return {
    source: "journal",
    columns: [],
    filters: [],
    sort: [],
  };
}

export function formatCell(value, column) {
  if (value === null || value === undefined || value === "") return "";
  if (column.type === "number") {
    return Number(value).toLocaleString("en-US", {
      // "plain": no trailing zeros (18, 5.5), as written to the CSV.
      minimumFractionDigits: column.format === "plain" ? 0 : column.decimals,
      maximumFractionDigits: column.decimals,
    });
  }
  return String(value);
}

// Preview periods of the editor, as [from, to] Date pairs.
export function presetRange(key, now = new Date()) {
  const start = new Date(now);
  start.setHours(0, 0, 0, 0);
  const endOfDay = (d) => {
    const x = new Date(d);
    x.setHours(23, 59, 0, 0);
    return x;
  };
  const monday = (d) => {
    const x = new Date(d);
    x.setDate(x.getDate() - ((x.getDay() + 6) % 7));
    return x;
  };
  switch (key) {
    case "today":
      return [start, now];
    case "yesterday": {
      const y = new Date(start);
      y.setDate(y.getDate() - 1);
      return [y, endOfDay(y)];
    }
    case "this_week":
      return [monday(start), now];
    case "this_month":
      return [new Date(start.getFullYear(), start.getMonth(), 1), now];
  }
  return null;
}

// The editor's preview periods.
export const PRESETS = ["today", "yesterday", "this_week", "this_month"];

export function toInput(d) {
  const p = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}T${p(d.getHours())}:${p(d.getMinutes())}`;
}
